/**
 * Split Image / Content block — video modal behaviour.
 *
 * When a play button is clicked:
 *  1. Find the paired <dialog> by ID (data-video-dialog attribute).
 *  2. Set the iframe src to the embed URL and open the dialog with showModal().
 *
 * When the dialog closes (close button, backdrop click, or Escape key):
 *  1. Clear the iframe src so the video stops.
 */

(function () {
    function openVideoDialog(btn) {
        var dialogId = btn.dataset.videoDialog;
        var embedUrl = btn.dataset.videoEmbed;
        if (!dialogId || !embedUrl) return;

        var dialog = document.getElementById(dialogId);
        if (!dialog) return;

        var iframe = dialog.querySelector('iframe');
        if (iframe) {
            iframe.src = embedUrl;
        }

        dialog.showModal();
    }

    function closeVideoDialog(dialog) {
        var iframe = dialog.querySelector('iframe');
        if (iframe) {
            iframe.src = '';
        }
        dialog.close();
    }

    document.addEventListener('click', function (e) {
        // Play button
        var playBtn = e.target.closest('.split-image-content__video-btn');
        if (playBtn) {
            openVideoDialog(playBtn);
            return;
        }

        // Close button
        var closeBtn = e.target.closest('.split-image-content__video-close');
        if (closeBtn) {
            var dialog = closeBtn.closest('.split-image-content__video-dialog');
            if (dialog) closeVideoDialog(dialog);
            return;
        }

        // Backdrop click — the <dialog> element itself is the backdrop target
        if (e.target.matches('.split-image-content__video-dialog')) {
            closeVideoDialog(e.target);
        }
    });

    // Native Escape key closes the dialog but we still need to clear the iframe.
    document.addEventListener('close', function (e) {
        if (e.target.matches && e.target.matches('.split-image-content__video-dialog')) {
            var iframe = e.target.querySelector('iframe');
            if (iframe) {
                iframe.src = '';
            }
        }
    }, true);
}());
